"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
var _withSizePresets = _interopRequireDefault(require("../withSizePresets"));
/* eslint-disable max-len */

var Delivery = function Delivery(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, (0, _extends2["default"])({
    viewBox: "0 0 37 25"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.321707711,1.95512821 L0.289533798,20.7373047 L4.37562075,20.7373047 C4.76170771,18.269356 6.91735988,16.3783303 9.52344684,16.3783303 C12.1295338,16.3783303 14.285186,18.269356 14.6712729,20.7373047 C14.7034468,20.9937149 14.7356208,21.2821765 14.7356208,21.570638 C14.7356208,21.7629457 14.7356208,21.9232021 14.7034468,22.1155098 L17.4060555,22.1155098 L17.3738816,-3.55271368e-15 L0.321707711,-3.55271368e-15 L0.321707711,1.95512821 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.8521739,9.80769231 L30.7582609,1.95512821 L30.4686957,9.23428001e-14 L19.7869565,9.23428001e-14 L19.8513043,22.0833333 L23.9052174,22.0833333 C23.8730435,21.9230769 23.8730435,21.7307692 23.8730435,21.5384615 C23.8730435,21.25 23.9052174,20.9935897 23.9373913,20.7051282 C24.3234783,18.2371795 26.4791304,16.3461538 29.0852174,16.3461538 C31.5304348,16.3461538 33.5895652,18.0128205 34.1365217,20.2884615 L36.8391304,20.2884615 L36.8391304,10.9294872 L31.8521739,9.80769231 L31.8521739,9.80769231 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.0852174,18.4935897 C27.3478261,18.4935897 25.9643478,19.8717949 25.9643478,21.6025641 C25.9643478,23.3333333 27.3478261,24.7115385 29.0852174,24.7115385 C30.8226087,24.7115385 32.206087,23.3333333 32.206087,21.6025641 C32.206087,19.8717949 30.8226087,18.4935897 29.0852174,18.4935897 L29.0852174,18.4935897 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.52347826,18.4935897 C7.78608696,18.4935897 6.4026087,19.8717949 6.4026087,21.6025641 C6.4026087,23.3333333 7.78608696,24.7115385 9.52347826,24.7115385 C11.2608696,24.7115385 12.6443478,23.3333333 12.6443478,21.6025641 C12.6443478,19.8717949 11.2286957,18.4935897 9.52347826,18.4935897 L9.52347826,18.4935897 Z"
  })));
};
var _default = (0, _withSizePresets["default"])(37, 25)(Delivery);
exports["default"] = _default;
//# sourceMappingURL=Delivery.js.map